import React from "react";
import style from "css/admin.module.css";

function AdminMain() {
  return <div className={style.wrapper}>1234</div>;
}

export default AdminMain;
